module.exports = __webpack_public_path__ + "img/ie.e3538ebd.svg";